import React, { Component } from "react";
import axios from "axios";
import * as api from "../../constants/api";
import { adalApiFetch } from "../../adalConfig";
import ReactTable from "react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "react-table/react-table.css";
import WhiteListDomainInfo from "../whitelistdomain/WhiteListDomainInfo";
import Modal from 'react-modal';
import { toastSuccess, toastError, customStyles } from '../../util/CommonFunctions'
import NavMenu from '../NavMenu'

Modal.setAppElement('#root')

class WhiteListDomainList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            WhiteListDomains: [],
            DisplayedCount: 0,
            Count: 0,
            Take: 10,
            ShowFilters: true,
            OrgData: {
                Id: 0,
                Domain: "",
            },
            Filter: [],
            IsLoaded: false,
            isDialogOpen: false,
            isEditDialogOpen: false,
            autofocusName: true,
            dataFilled: false
        };
    }    
    

    componentDidMount() {
        this.getInitial();
    }

    componentDidUpdate() {
        if (this.state.OrgData.Domain !== "") {
            if (this.state.dataFilled === false) {
                this.setState({ dataFilled: true });
            }
        }
        else {
            if (this.state.dataFilled === true) {
                this.setState({ dataFilled: false });
            }
        }
    }

    focusName = e => {
        this.setState({ autofocusName: true });
    }
   

    handleDomainChange = e => {
        const val = e.target.value;
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.Domain = val;
        this.setState({ OrgData: orgData});
        this.focusName();
    };

    openDialog(id) {
        this.setState({ isDialogOpen: true })
        this.setState({ rowID: id })
    }

    handleClose = () => this.setState({ isDialogOpen: false, isEditDialogOpen: false })


    render() {
        const {
            WhiteListDomains: data,
            IsLoaded
        } = this.state;

        const { canCreateRWAMapping, canViewRWAMapping } = this.props;

        const columns = [
            {
                Header: "ID",
                accessor: "id",
                maxWidth: 80
            },
            {
                Header: "Domain",
                accessor: "domain",
                filterMethod: this.defaultFilter
            },
            {
                Header: "Edit",
                style: { flex: "1" },
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                filterable: false,
                sortable: false,
                Cell: props => {
                    return (
                        <div>
                            {canCreateRWAMapping && (
                                <button className="btn small"
                                onClick={() => {
                                    let selRow = props.row._original;
                                    this.handleClickEdit(selRow);
                                }} >
                                <FontAwesomeIcon icon="edit" color="Grey" />
                            </button>
                            )}
                        </div>
                    );
                }
            },
            {
                Header: "Delete",
                style: { flex: "1" },
                width: 100,
                minWidth: 100,
                maxWidth: 100,
                filterable: false,
                sortable: false,
                Cell: props => {
                    return (
                        <div>
                            {canCreateRWAMapping && (
                                <div>
                                    <button className="btn small"
                                        onClick={() => { this.openDialog(props.row._original.id); }} >
                                        <FontAwesomeIcon icon="trash" color="Grey" />
                                    </button>
                                    <Modal isOpen={this.state.isDialogOpen} style={customStyles} overlayClassName="Overlay" >
                                        <div>
                                            <div className="modalDivHeader">
                                            </div>
                                            <div className="details-section-header modalLabel">
                                                <label className="modalLabel">  Delete WhiteList Domain </label>
                                                <button id="btnClose" onClick={this.handleClose}>  X  </button>
                                            </div>
                                            <h4 className="lblNVGreen">Are you sure you want to delete record {this.state.rowID} ?</h4>
                                            <center>
                                                <button className="btn" onClick={() => this.handleClickDelete(this.state.rowID)}> Yes </button>
                                            </center>
                                        </div>
                                    </Modal>
                                </div>
                            )}
                        </div>
                    );
                }
            },
        ];

        if (!IsLoaded) {
            return (
                <div className="loading-full">
                    <FontAwesomeIcon
                        icon="spinner"
                        spin
                        className="color-nvgreen"
                        size="2x"
                    />
                    <div className="loading-text">loading page content</div>
                </div>
            );
        }

        return (
            <div>
                {canViewRWAMapping && (
                    <NavMenu />
                )}
                {canCreateRWAMapping && (
                    <div className="flex-fill">
                        <div className="divAddBtn">
                            <button className="btn" id="btnAdd" onClick={() => { this.handleClickEdit() }} >
                                <FontAwesomeIcon icon="plus" />
                            </button>
                        </div>
                    </div>
                )}
                
                <Modal isOpen={this.state.isEditDialogOpen} style={customStyles} overlayClassName="Overlay">
                    <div>
                        <div className="modalDivHeader">
                        </div>
                        <div className="details-section-header modalLabel">
                            <label className="modLabel"> WhiteList Domain Maintenance </label>
                            <button id="btnClose" onClick={this.handleClose}>  X  </button>
                        </div>
                        <WhiteListDomainInfo
                            orgData={this.state.OrgData}
                            handleDomainChange={this.handleDomainChange}
                            autoFocusName={this.state.autofocusName}
                            dataFilled={this.state.dataFilled}
                            onSaveClick={this.handleSaveClick} />
                    </div>
                </Modal>

                <div className="content" >
                    <h4 className="lblNVGreen"> WhiteList Domains </h4>

                    {canViewRWAMapping && (
                        <div>
                            <ReactTable
                            data={data}
                            columns={columns}
                            defaultPageSize={this.state.Take}
                            minRows={0}
                            filterable={this.state.ShowFilters}
                            resizable={false}
                            className="-striped -highlight"
                            filtered={this.state.Filter}
                            onFilteredChange={filtered => {
                                this.setState({ Filter: filtered });
                            }}
                        >
                            {(state, makeTable, instance) => {
                                let recordsInfoText = "";

                                const { filtered, pageRows, pageSize, sortedData, page } = state;

                                if (sortedData && sortedData.length > 0) {
                                    let isFiltered = filtered.length > 0;
                                    let totalRecords = sortedData.length;
                                    let recordsCountFrom = page * pageSize + 1;
                                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                                    if (isFiltered)
                                        recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
                                    else
                                        recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
                                } else recordsInfoText = "No records";

                                const dashboard = (
                                    <div className="dashboard">
                                        <div className="dashboard-text">{recordsInfoText}</div>
                                    </div>
                                );
                                return (
                                    <div>
                                        {dashboard}
                                        {makeTable()}
                                    </div>
                                );
                            }}
                        </ReactTable>
                            <div id="divTbl"> </div>
                        </div>
                    )}
                 </div>

            </div>
        );
    }
    handleSaveClick = e => {
        let orgData = Object.assign({}, this.state.OrgData);
        let id = parseInt(orgData.Id) ? parseInt(orgData.Id) : 0;

        let data = {
            Id: id,
            Domain: orgData.Domain
        };

        if (data.Domain === "" ) {
            toastError("Domain is Required");
            return false;
        }

        adalApiFetch(
            axios,
            api.POST_CREATE_WHITELIST_DOMAIN,
            {
                method: "post",
                data: data,
            }
        )
        .then(response => {
            console.log(response);
            this.getInitial();
            this.resetElements();
            toastSuccess(response.data["Data"] || "Domain saved successfully");
      })
        .catch(error => {
            console.log(error);
            if (error.response) {
                if (error.response.data.title)
                    toastError(JSON.stringify(error.response.data["errors"]));
                else
                    toastError(error.response.data["Message"]);
            }
        });
    }

    resetElements = e => {
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.Id = 0;
        orgData.Domain = "";
        this.setState({ OrgData: orgData, isDialogOpen: false, isEditDialogOpen: false }, function () { });
    }

    handleClickEdit(selRow) {
        console.log(selRow);
        this.setState({ isEditDialogOpen: true })
        let orgData = Object.assign({}, this.state.OrgData);
        orgData.Id = selRow ? selRow.id : 0;
        orgData.Domain = selRow ? selRow.domain : "";
        this.setState({ OrgData: orgData, isEditDialogOpen: true }, function () {
            console.log(this.state.OrgData);
        });
        this.focusName();
    }

    handleClickDelete(id) {
        adalApiFetch(
            axios,
            api.DELETE_WHITELIST_DOMAIN + '/' + parseInt(id),
            {
                method: "delete",
            }
        )
        .then(res => {
            console.log(res.data);
            this.handleClose();
            this.getInitial();
            toastSuccess(res.data["Data"] || "Domain deleted successfully");
       })
        .catch(error => {
            console.log(error);
            if (error.response) {
                console.log(error.response);
                toastError(error.response.data["Message"]);
            }
        });
    }

    defaultFilter(filter, row, column) {
        return (
            row[filter.id] &&
            row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
        );
    }

    getInitial() {
        adalApiFetch(axios, api.GET_WHITELIST_DOMAINS, {})
            .then(response => {
                const modifiedData = response.data.map(r => {
                    return r;
                });

                this.setState({
                    IsLoaded: true,
                    WhiteListDomains: modifiedData,
                    Count: response.data.totalCount,
                    DisplayedCount: this.state.Take,
                    GetMoreEnabled: true
                });
            })
            .catch(error => {
                console.log(error.response);
            });
    }
}

export default WhiteListDomainList;

